import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

export default class MtnZAService {
    static async updateUsername(msisdn, productId, username) {
        try {
            return await axios.post(`${environmentConfig.depService}/update-username`, {
                    msisdn,
                    productId,
                    username
                }
            )
        } catch (e) {
            return {authError: true};
        }
    }

    static async getUserViaMsisdn(msisdn, productId) {
        try {
            return await axios.post(`${environmentConfig.depService}/get-user-via-msisdn`, {
                    msisdn,
                    productId
                }
            )
        } catch (e) {
            return {authError: true};
        }
    }

    static async validateMyBundleEntry(productId, rawQueryString) {
        try {
            return await axios.post(`${environmentConfig.depService}/my-bundle/validate-entry`, {
                    productId,
                    rawQueryString
                }
            )
        } catch (e) {
            return {authError: true};
        }
    }

    static async requestOtp(msisdn, productId) {
        return await axios.post(`${environmentConfig.depService}/request-otp`, {
                msisdn,
                productId
            }
        )
    }

    static async validateOtp(msisdn, productId, otp) {
        return await axios.post(`${environmentConfig.depService}/validate-otp`, {
                msisdn,
                productId,
                otp,
            }
        )
    }
}
